import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateBreakoutBannerImage } from "../../../../../store/actions/admin/create-event/session";
import { useTypedSelector } from "../../../../../store/reducers/use-typed-selector";

import { Session } from "../../../../../types/working-model";
import { OptionalComponent } from "../../../../../utils/optional-component";
import Icon, { ICONS } from "../../../../general-ui/icon";
import StandardImageUpload from "../../../../general-ui/image-upload-modal/standard-image-upload";
import EditBannerColor from "./edit-banner-color";

interface IBreakoutBannerActions {
	session: Session;
}

const BreakoutBannerActions: React.FC<IBreakoutBannerActions> = ({ session }) => {
	const [imageModalOpen, setImageModalOpen] = useState(false);
	const sessionId = useTypedSelector(state => state.CreateSessionReducer.workingSession?.session);
	const token = useTypedSelector(state => state.AuthReducer.token);
	const disableSessionThumbnails = useTypedSelector(state => state.CreateEventReducer.workingEvent?.settings?.disable_session_thumbnails);

	const dispatch = useDispatch();

	const handleShowImageUpload = () => {
		setImageModalOpen(prev => !prev);
	};

	const handleClose = () => setImageModalOpen(false);

	const handleSave = (image: string) => {
		if (!token || !sessionId) return;
		// update db and redux
		// use the existing background image in breakout_sessions that was previously built for "chat"
		dispatch(updateBreakoutBannerImage(image || null, sessionId, token));
		setImageModalOpen(false);
	};

	return (
		<div className="breakout-banner-actions">
			<OptionalComponent display={!disableSessionThumbnails}>
				<>
					<StandardImageUpload
						onClose={handleClose}
						onSave={handleSave}
						open={imageModalOpen}
						defaultImage={session?.breakout_session?.banner_image || ''}
					/>
					<button
						className="round"
						onClick={handleShowImageUpload}
					><Icon name={ICONS.IMAGE} size={16} color="default" /></button>
				</>
			</OptionalComponent>
			<OptionalComponent display={disableSessionThumbnails}>
				<EditBannerColor />
			</OptionalComponent>

		</div>
	);
};

export default BreakoutBannerActions;
